/**
 * 这个工具主要的是处理缓存的方法
 */

/**
 * 存入浏览器cookie
 * @param name cookie名称
 * @param value cookie值
 * @param time 失效时间
 */
export function addCookie(name: string, value: string, time?: string, path?: string) {
  let cookieString: string = name + '=' + value;
  if (!!!path) {
    cookieString = cookieString + ';path=' + path;
  }
  document.cookie = cookieString;
}

/**
 * 删除浏览器cookie
 * @param name cookie名称
 */
export function delCookie(name: string) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  // 获取cookie是否存在
  var value = getCookie(name);
  if (value != null) {
    document.cookie = name + '=' + value + ';expires=' + exp.toUTCString();
  }
}

/**
 * 获取浏览器cookie
 * @param name cookie名称
 */
export function getCookie(name: string) {
  // 获取当前所有cookie
  var strCookies = document.cookie;
  // 截取变成cookie数组
  var array = strCookies.split('; ');
  // 循环每个cookie
  for (var i = 0; i < array.length; i++) {
    // 将cookie截取成两部分
    var item = array[i].split('=');
    // 判断cookie的name 是否相等
    if (item[0] === name) {
      return item[1];
    }
  }
  return '';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/cookieUtils.ts